module.exports = __webpack_public_path__ + "static/media/logo_146x34.50fd5586.svg";